import moment from "moment";
import { useState } from "react"
import apiBeps from "../api/Beps/api-beps";
import { FormBeps } from "../models/Beps/beps.model";
import { openNotification } from "../utils/saveFile";
import getStorageUser from "../middlewares/GetStorageUser"
import apiParticipantes from "../api/Participantes/api-participantes";
import { useEncrypt } from "./useEncrypt";
import { ObjNotificaciones } from "../config/notificaciones";
import { useNavigate } from "react-router-dom";

export const useBepsFormN = () => {

    const [formBeps, setFormBeps] = useState<FormBeps>(initialValues);
    const [documentosBeps, setdocumentosBeps] = useState(documentos);
    const [editBeps, setEditBeps] = useState(false);
    const { decrypt } = useEncrypt();
    const navigate = useNavigate();

    const [openDatePickerExpedicion, setOpenDatePickerExpedicion] = useState(false);
    const obtenerFechaDatePickerExpedicion = (fecha: any): void => {

        if (parseInt(moment(fecha).format("YYYYMMDD")) > parseInt(moment().format("YYYYMMDD"))) {
            return openNotification({
                titulo: "Error",
                descripcion: "La fecha seleccionada es mayor a la actual",
                placement: "bottomRight",
            });
        }

        let fechanacimiento = moment(fecha, "DD-MM-YYYY");
        let years = moment().diff(fechanacimiento, 'years');


        if (years > 100) {
            return openNotification({
                titulo: "Error",
                descripcion: "No puedes escoger fechas mayores a 100 años",
                placement: "bottomRight",
            });
        }

        setOpenDatePickerExpedicion(false);
        setFormBeps({
            ...formBeps,
            fecha_expedicion_dia: moment(fecha).format("DD"),
            fecha_expedicion_mes: moment(fecha).format("MM"),
            fecha_expedicion_año: moment(fecha).format("YYYY"),
            fecha_expedicion: moment(fecha).format("YYYY-MM-DD"),
        })
    }

    const [openDatePickerNacimiento, setOpenDatePickerNacimiento] = useState(false);
    const obtenerFechaDatePickerNacimiento = (fecha: any): void => {

        if (parseInt(moment(fecha).format("YYYYMMDD")) > parseInt(moment().format("YYYYMMDD"))) {
            return openNotification({
                titulo: "Error",
                descripcion: "La fecha seleccionada es mayor a la actual",
                placement: "bottomRight",
            });
        }

        let fechanacimiento = moment(fecha, "DD-MM-YYYY");
        let years = moment().diff(fechanacimiento, 'years');

        if (years < 18) {
            return openNotification({
                titulo: "Error",
                descripcion: "La persona no puede ser menor de edad",
                placement: "bottomRight",
            });
        }

        if (years > 100) {
            return openNotification({
                titulo: "Error",
                descripcion: "No puedes escoger fechas mayores a 100 años",
                placement: "bottomRight",
            });
        }

        setOpenDatePickerNacimiento(false);
        setFormBeps({
            ...formBeps,
            fecha_nacimiento_dia: moment(fecha).format("DD"),
            fecha_nacimiento_mes: moment(fecha).format("MM"),
            fecha_nacimiento_año: moment(fecha).format("YYYY"),
            fecha_nacimiento: moment(fecha).format("YYYY-MM-DD"),
        })
    }


    const [tab, setTab] = useState(1);
    const nextTab = () => {
        setTab(tab + 1);
    };

    const prevTab = () => {
        setTab(tab - 1);
    };

    const guardarFormulario = async () => {
        const id_convocatoria = decrypt(localStorage.getItem('idConvocatoriaPostulacion'));
        const validacionPostulacionJurado = await apiParticipantes.validarPostulacion(id_convocatoria, Number(formBeps.numero_documento));

        if (validacionPostulacionJurado.data !== null) {
            ObjNotificaciones.MSG_ERROR('warning', '¡Ya te inscribiste a esta convocatoria!', 'Por favor, postúlate a una nueva convocatoria');
            return navigate('/usuario');
        }

        if (!editBeps) {
            formBeps.fecha_expedicion = `${formBeps.fecha_expedicion_año}-${formBeps.fecha_expedicion_mes}-${formBeps.fecha_expedicion_dia}`
            formBeps.fecha_nacimiento = `${formBeps.fecha_nacimiento_año}-${formBeps.fecha_nacimiento_mes}-${formBeps.fecha_nacimiento_dia}`
            let {
                fecha_expedicion_dia,
                fecha_expedicion_mes,
                fecha_expedicion_año,
                fecha_nacimiento_dia,
                fecha_nacimiento_mes,
                fecha_nacimiento_año,
                ...demasDatos
            } = formBeps;


            if (parseInt(moment(demasDatos.fecha_nacimiento).format("YYYYMMDD")) > parseInt(moment().format("YYYYMMDD"))) {
                return openNotification({
                    titulo: "Error",
                    descripcion: "La fecha nacimiento seleccionada es mayor a la actual",
                    placement: "bottomRight",
                });
            }

            if (parseInt(moment(demasDatos.fecha_expedicion).format("YYYYMMDD")) > parseInt(moment().format("YYYYMMDD"))) {
                return openNotification({
                    titulo: "Error",
                    descripcion: "La fecha expedición seleccionada es mayor a la actual",
                    placement: "bottomRight",
                });
            }

            try {
                const resp = await apiBeps.postBeps(demasDatos);
                console.log(resp)
                nextTab();
            } catch (error) {
                console.log(error)
            }
        } else {
            actualizarFormulario()
        }
    }

    const actualizarFormulario = async () => {

        let {
            fecha_expedicion_dia,
            fecha_expedicion_mes,
            fecha_expedicion_año,
            fecha_nacimiento_dia,
            fecha_nacimiento_mes,
            fecha_nacimiento_año,
            ...demasDatos
        } = formBeps;

        try {
            nextTab();
        } catch (error) {
            console.log(error)
        }
    }

    const handleSearchDocument = async (documento: any) => {

        try {
            //
            const beps = await apiBeps.getBepByDocument(documento);
            if (beps.message) {
                const user = getStorageUser()
                setFormBeps({
                    ...formBeps,
                    numero_documento: user.documento,
                    primer_nombre: user.nombres,
                    primer_apellido: user.apellidos,
                    sexo: user.sexo,
                    departamento_residencia: user.departamento,
                    municipio_residencia: user.municipio
                });



            } else {
                setEditBeps(true)
                setFormBeps({
                    ...beps,
                    fecha_expedicion_dia: moment(beps.fecha_expedicion).format("DD"),
                    fecha_expedicion_mes: moment(beps.fecha_expedicion).format("MM"),
                    fecha_expedicion_año: moment(beps.fecha_expedicion).format("YYYY"),
                    fecha_nacimiento_dia: moment(beps.fecha_nacimiento).format("DD"),
                    fecha_nacimiento_mes: moment(beps.fecha_nacimiento).format("MM"),
                    fecha_nacimiento_año: moment(beps.fecha_nacimiento).format("YYYY"),
                    tipo_ingresos: Number(beps.tipo_ingresos),
                    actividad_actual: Number(beps.actividad_actual)
                    // discapacidad_fisica: Number(beps.discapacidad_fisica)
                });
            }
        } catch (error) {
            console.log(error);
        }
    }





    return {
        formBeps,
        setFormBeps,
        openDatePickerExpedicion,
        setOpenDatePickerExpedicion,
        obtenerFechaDatePickerExpedicion,
        openDatePickerNacimiento,
        setOpenDatePickerNacimiento,
        obtenerFechaDatePickerNacimiento,
        guardarFormulario,
        handleSearchDocument,
        tab,
        nextTab,
        prevTab,
        actualizarFormulario,
        documentosBeps,
        setdocumentosBeps,
        editBeps,
        setEditBeps
    }
}


const initialValues = {
    numero_documento: '',
    tipo_agente: null,
    primer_nombre: '',
    segundo_nombre: '',
    primer_apellido: '',
    segundo_apellido: '',
    fecha_nacimiento: '',
    fecha_nacimiento_dia: '',
    fecha_nacimiento_mes: '',
    fecha_nacimiento_año: '',
    fecha_expedicion: '',
    fecha_expedicion_dia: '',
    fecha_expedicion_mes: '',
    fecha_expedicion_año: '',
    sexo: null,
    departamento_nacimiento: 1,
    municipio_nacimiento: 1,
    grupo_etnico: null,
    departamento_residencia: null,
    municipio_residencia: null,
    area: null,
    localidad: '',
    direccion: '',
    tiempo_residencia: '',
    con_quien_reside: null,
    otro_con_quien_reside: '',
    dependencia_economica: null,
    discapacidad_fisica: null,
    tipo_discapacidad: null,
    otra_discapacidad: '',
    correo_electronico: '',
    telefono_celular: '',
    telefono_fijo: '',
    web: '',
    sisben: null,
    puntaje_sisben: null,
    listado_censal: null,
    listado_censal_cual: '',
    seguridad_social_regimen_id: null,
    nivel_educativo_id: null,
    area_id: null,
    otra_area: '',
    tipo_ingresos: null,
    principal_actividad_id: null,
    principal_actividad_cual: '',
    tiempo_actividad_principal: '',
    desarrolla_actividad: null,
    actividad_actual: null,
    actividad_actual_cual: '',
    tiempo_actividad_actual: '',
    tipo_contrato: null,
    contrato: null,
}

const documentos = [
    {
        tipo_documento: "Documento de identidad",
        url_documento: "",
        url_participante: "",
        descripcion: "Cargar archivo PDF",
        activo: false,
        subsanable: true,
    },
    {
        tipo_documento: "Declaración juramentada de residencia",
        url_documento: "Declaracion.docx",
        url_participante: "",
        descripcion: "Presentar declaración juramentada de residencia según el formato anexo.",
        activo: false,
        subsanable: true,
    },
    {
        tipo_documento: "Cuenta de servicios públicos",
        url_documento: "",
        url_participante: "",
        descripcion: "Última factura de servicios públicos del lugar de residencia",
        activo: false,
        subsanable: true,
    },
    {
        tipo_documento: "Certificado cultural y trayectoria",
        url_documento: "",
        url_participante: "",
        descripcion: "Certificado cultural y trayectoria",
        activo: false,
        subsanable: true,
    },
    {
        tipo_documento: "Certificado de socialización ante el público",
        url_documento: "",
        url_participante: "",
        descripcion: "Certificado de socialización ante el público",
        activo: false,
        subsanable: true,
    },
    {
        tipo_documento: "Encuesta Sisbén",
        url_documento: "",
        url_participante: "",
        descripcion: "Encuesta Sisbén",
        activo: false,
        subsanable: true,
    },
    {
        tipo_documento: "Cerficiado de discapacidad",
        url_documento: "",
        url_participante: "",
        descripcion: "Cerficiado de discapacidad",
        activo: false,
        subsanable: true,
    },
    {
        tipo_documento: "Cetificado de libertad económica",
        url_documento: "",
        url_participante: "",
        descripcion: "Cetificado de libertad económicat",
        activo: false,
        subsanable: true,
    },
]